export default "__VITE_ASSET__cb7371cc__"